export default class CDNUtils {

    public static usingCDN(): boolean {
        let wp: string = window.location.hostname;
        return CDNUtils.isLglass(wp) || CDNUtils.isZazer(wp);
    }

    public static getStaticUrl(withSlash: boolean): string {
        let wp: string = window.location.hostname;
        let baseUrl = '/';
        if (CDNUtils.isZazer(wp)) {
            baseUrl = 'https://static.zazer.mobi';
        } else if (CDNUtils.isLglass(wp)) {
            baseUrl = 'https://stat.lglass.mobi';
        }
        return withSlash ? (baseUrl + '/') : baseUrl;
    }

    private static isLglass(wp: string) {
        return 'lglass.mobi' === wp || 'apk.lglass.mobi' === wp;
    }

    private static isZazer(wp: string) {
//        return false;
        return 'ok.zazer.mobi' === wp
            || 'thor.zazer.mobi' === wp
            || 'ya.zazer.mobi' === wp
            || 'vk.zazer.mobi' === wp
            || 'mystore.zazer.mobi' === wp
            || 'foto.zazer.mobi' === wp
            || 'exe.zazer.mobi' === wp
            || 'beeline.zazer.mobi' === wp
            || 'alex.zazer.mobi' === wp
            || 'tg.zazer.mobi' === wp
            || 'zazer.mobi' === wp
            || 'gp.zazer.mobi' === wp;
    }
}